import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]

import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'SelectImage',
  props: {
edicion:
{
    type: Boolean,
    default: false,
    required:true
},
nameControl:
{
    type: String,
    default: "inpImgSelectCtrl"
}},
  emits: ['onSetFile','onPreview'],
  setup(__props, { emit: __emit }) {

const emits = __emit; 
const props = __props;
const image = ref<any>();
const hasImage = ref<boolean>(false);
const SelectImage =()=>
{    
    if (props.edicion)
    {
      const file = document.getElementById(props.nameControl + '_file'); 
      if(file)
      {        
        file.click();
      }
    }
}
const PreviewArchivo = (event:any)=>
{   
    const inp = event.target;
    if (inp.files && inp.files[0]) 
    {
        const reader = new FileReader();
        reader.onload = (e: any) =>
        {
            image.value = e.target.result;              
            emits('onPreview',e.target.result);        
        };
        reader.readAsDataURL(inp.files[0]);
        hasImage.value = true;
        emits('onSetFile',inp.files[0]);        
    }
    else
    {
        image.value = '';
        hasImage.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { onClick: SelectImage }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", {
      id: __props.nameControl,
      class: _normalizeClass(__props.nameControl + ' d-none ')
    }, [
      _createElementVNode("input", {
        id: __props.nameControl + '_file',
        type: "file",
        onChange: PreviewArchivo
      }, null, 40, _hoisted_2)
    ], 10, _hoisted_1)
  ]))
}
}

})